
(function ($) {
  'use strict';
  var request, generation = 0, trigger;
  function showPopup(selector) { $(selector).addClass('active'); }
  function hidePopup(selector) { $(selector).removeClass('active'); }
  window.showPopup = showPopup;

  function closeQuickview() {
    generation++;
    if (request) request.abort();
    hidePopup('.quickview-product');
    hidePopup('.loading');
    $('.loading').removeClass('loaded-content');
    if (trigger) trigger.focus();
  }

  function openQuickview(button) {
    trigger = button;
    if (request) request.abort();
    var current = ++generation;
    showPopup('.loading');
    request = $.getJSON('/products/' + encodeURIComponent(button.dataset.id) + '.js').done(function (product) {
      if (current !== generation) return;
      var $view = $('.quickview-product');
      $view.html($('#quick-view').html());
      $view.find('.content').attr({ role: 'dialog', 'aria-modal': 'true', 'aria-label': product.title, tabindex: '-1' });
      $view.find('.close-window').attr('aria-label', window.inventory_text.close);
      $view.find('.product-name a').text(product.title).attr('href', product.url);
      $view.find('.des').text($('<div>').html(product.description).text().split(/\s+/).slice(0, 20).join(' '));
      var form = $view.find('[data-maison-product-form]')[0];
      var formId = 'MaisonQuickviewForm-' + product.id;
      form.setAttribute('id', formId);
      form.dataset.maisonAddLabel = window.inventory_text.add_to_cart;
      var select = form.querySelector('[name="id"]');
      select.id = formId + '-Variant';
      product.variants.forEach(function (variant) {
        var option = new Option(variant.title, variant.id);
        option.disabled = !variant.available;
        select.add(option);
      });
      select.value = (product.variants.find(function (variant) { return variant.available; }) || product.variants[0]).id;
      if (product.variants.length > 1 && window.use_color_swatch) {
        product.options.forEach(function (option, index) {
          var name = typeof option === 'string' ? option : option.name;
          var swatch = $('<div class="swatch clearfix"></div>').attr({ 'data-option-index': index, role: 'group', 'aria-label': name });
          $('<p class="text-uppercase title_variant"></p>').text(name).appendTo(swatch);
          Array.from(new Set(product.variants.map(function (variant) { return variant.options[index]; }))).forEach(function (value, valueIndex) {
            var id = formId + '-swatch-' + index + '-' + valueIndex;
            var item = $('<div class="maxus-color none"></div>').attr('data-value', value);
            $('<input type="radio">').attr({ id: id, name: 'option-' + index, value: value, 'aria-label': name + ': ' + value }).appendTo(item);
            $('<label class="variant_other"></label>').attr('for', id).text(value).appendTo(item);
            item.appendTo(swatch);
          });
          $(select).before(swatch);
        });
      }
      var quantity = form.querySelector('[name="quantity"]');
      quantity.id = formId + '-Quantity';
      function addImage(src, parent, className) {
        $('<img>').attr({ src: src, alt: product.title }).addClass(className).appendTo(parent);
      }
      if (product.featured_image) {
        var link = $('<a class="product-photo"></a>').attr('href', product.url).appendTo($view.find('.featured-image'));
        addImage(Shopify.resizeImage(product.featured_image, 'grande'), link, 'engoj_img_main_quickview w-100 img-fluid');
      }
      var carousel = $view.find('.more-views .owl-carousel');
      product.images.forEach(function (src) {
        var item = $('<div class="item"></div>').appendTo(carousel);
        var link = $('<a></a>').attr({ href: src, 'data-image': Shopify.resizeImage(src, 'grande') }).appendTo(item);
        addImage(Shopify.resizeImage(src, 'compact'), link, 'w-100');
      });
      if (!product.images.length) $view.find('.more-views').remove();
      carousel.on('click.maisonMedia', 'a', function (event) {
        event.preventDefault();
        $view.find('.featured-image img').attr('src', this.dataset.image);
      });
      window.MaisonProductForms.init($view[0], product, false);
      showPopup('.quickview-product');
      $('.loading').addClass('loaded-content');
      if (product.images.length > 3 && $.fn.slick) carousel.slick({ slidesToShow: 3, slidesToScroll: 1, dots: false, arrows: false });
      $view.find('.content')[0].focus({ preventScroll: true });
      $view.find('.popup-quickview').scrollTop(0);
    }).fail(function (xhr, status) {
      if (status === 'abort' || current !== generation) return;
      hidePopup('.loading');
      $('.error-popup .error-message').text(window.inventory_text.unavailable);
      showPopup('.error-popup');
    });
  }

  function quickView() {
    $(document).off('click.maisonQuickview', '.engoj_btn_quickview').on('click.maisonQuickview', '.engoj_btn_quickview', function (event) {
      if ($(window).width() < 992) {
        this.href = '/products/' + encodeURIComponent(this.dataset.id);
        return;
      }
      event.preventDefault();
      openQuickview(this);
    });
  }
  window.quickView = quickView;
  $(quickView);
  $(document).on('click.maisonQuickviewClose', '.overlay-quickview, .quickview-product .close-window', function (event) {
    event.preventDefault();
    closeQuickview();
  });
  $(document).on('keydown.maisonQuickview', function (event) {
    if (!$('.quickview-product').hasClass('active')) return;
    if (event.key === 'Escape') { closeQuickview(); return; }
    if (event.key !== 'Tab') return;
    var controls = $('.quickview-product').find('a[href], button:not(:disabled), input:not(:disabled), select:not(:disabled)').filter(':visible');
    var first = controls[0], last = controls[controls.length - 1];
    if (event.shiftKey && (document.activeElement === first || document.activeElement.classList.contains('content'))) { event.preventDefault(); last.focus(); }
    else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
  });
  $(document).on('click.maisonPopupClose', '.overlay, .continue-shopping, .tshopify-popup .close-window', function (event) {
    event.preventDefault();
    hidePopup('.tshopify-popup');
    $('.loading').removeClass('loaded-content');
  });
})(jQuery);

